import React, { Component } from "react"

export default class CBH21 extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Copenhagen Hackathon 2021</p>
            <p className="portdesctext">Award winning project recipient for <a href = "https://biohackathon.biolib.com/event/2021-protein-edition" target="_blank" rel="noopener noreferrer">Copenhagen Hackathon 2021</a>. Organised two teams: <a href = "https://biolib.com/N-SVAMT-4c7y/N-SVAMT/" target="_blank" rel="noopener noreferrer">N-SVMAT</a> & <a href = "https://biolib.com/Illumina-ti-vlf2/Illumina-ti/" target="_blank" rel="noopener noreferrer">Illumina-ti</a>. N-SVMAT received Mentor's award & submitted a top model, <a href = "https://docs.google.com/presentation/d/1yvGTnV25KXr02rW6vWGTcZ0B72MdcZTKwEZ4Sz7bDvM/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Illumina-ti</a> placed 2nd & received accolades from Mentors.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://github.com/ternlef11/tcr-pmhc" target="_blank" rel="noopener noreferrer"><p className="linktext">Repo</p></a>
        </div>
      </div>
  )
}
}

